import { Table, Text } from '@mantine/core';
import clsx from 'clsx';
import { ReactNode } from 'react';

type TableHeaderCellProps = {
    children?: ReactNode
    subLabel?: string
    indent?: boolean
}

export const TableHeaderCell = ({ children, subLabel, indent }: TableHeaderCellProps) => {
    return (
        <Table.Th className={clsx('min-w-12 max-w-24 h-20 border-border-ultra-light', {
            'border-r': !children && !subLabel
        })}>
            <Text className={clsx({
                'pl-2': indent
            })}>
                {children}
            </Text>
            {subLabel &&
                <Text className={clsx('text-sm text-text-light', {
                    'pt-6': !children,
                    'pl-2': indent
                })}>
                    {subLabel}
                </Text>}
        </Table.Th>
    );
};